import moment from "moment"

export const diffTime = (start, end, type) =>{
    let inicia = start ? moment(start, "YYYY-MM-DDTHH:mm:ss") : null
    let finaliza = end ? moment(end, "YYYY-MM-DDTHH:mm:ss") : null

    if(inicia && finaliza){
        return finaliza.diff(inicia, type) + type[0]
    }else{
        return '-'
    }


}